module.exports = __webpack_public_path__ + "img/img (36).814335d0.jpg";